import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useT } from "../i18n/I18nProvider";
import { useNavItems } from "./Header";

export const Footer = () => {
  const t = useT();
  const navItems = useNavItems();

  return (
    <footer
      className="mt-20 md:mt-32 border-t border-ink-200 bg-cream"
      data-testid="site-footer"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 pt-16 md:pt-24 pb-10 md:pb-14">
        <div className="grid lg:grid-cols-12 gap-10 md:gap-14">
          <div className="lg:col-span-6">
            <div className="overline mb-4 md:mb-6">{t("footer.overline")}</div>
            <h3 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.98] tracking-tightest">
              {t("footer.headline1")}{" "}
              <span className="font-editorial text-ink-700">
                {t("footer.headlineEditorial")}
              </span>
              <br /> {t("footer.headline2")}
            </h3>
            <Link
              to="/contatti"
              className="btn-pill mt-8 md:mt-10"
              data-testid="footer-contact-cta"
            >
              {t("common.iniziamoProgetto")}
              <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.6} />
            </Link>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-4 md:mb-5">{t("footer.navHeading")}</div>
            <ul className="space-y-2.5 md:space-y-3 text-[15px]">
              {navItems
                .concat({ to: "/contatti", label: t("nav.contatti"), key: "contatti" })
                .map((n) => (
                  <li key={n.to}>
                    <Link
                      to={n.to}
                      className="text-ink-700 hover:text-ink-900 underline-grow"
                    >
                      {n.label}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-4 md:mb-5">
              {t("footer.writeHeading")}
            </div>
            <a
              href="mailto:info@mysteriousstew.com"
              className="text-[15px] text-ink-900 underline-grow break-all"
              data-testid="footer-email"
            >
              info@mysteriousstew.com
            </a>
            <p className="mt-4 md:mt-6 text-[13px] text-ink-500 leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>
        </div>

        <div className="mt-14 md:mt-20 pt-6 md:pt-8 border-t border-ink-200 flex flex-col md:flex-row md:items-center md:justify-between gap-2 md:gap-3 overline">
          <span>
            © {new Date().getFullYear()} Mysterious Stew — {t("footer.rights")}
          </span>
          <span>{t("footer.madeWith")}</span>
        </div>
      </div>
    </footer>
  );
};
